import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-icon',
  templateUrl: './listing-icon.component.html',
  styles: []
})
export class ListingIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
